/* ==========================================================================
   VOLTAUTO Theme — JavaScript principal
   Interactions globales : mega menu, carousels, language detection, forms.
   Utilise Alpine.js (chargé depuis CDN) pour les comportements déclaratifs.
   ========================================================================== */

(function () {
  'use strict';

  // Mark JS available (for progressive enhancement)
  document.documentElement.classList.remove('no-js');
  document.documentElement.classList.add('js');

  // ---------- Mobile menu toggle ----------
  const mobileToggle = document.querySelector('[data-mobile-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      const isOpen = mobileMenu.getAttribute('data-open') === 'true';
      mobileMenu.setAttribute('data-open', !isOpen);
      mobileToggle.setAttribute('aria-expanded', !isOpen);
      document.body.style.overflow = !isOpen ? 'hidden' : '';
    });
  }

  // ---------- Carousels (Instagram, vehicles, etc.) ----------
  document.querySelectorAll('[data-carousel]').forEach(carousel => {
    const prev = carousel.parentElement.querySelector('[data-carousel-prev]');
    const next = carousel.parentElement.querySelector('[data-carousel-next]');
    const scrollAmount = carousel.dataset.scrollAmount ? parseInt(carousel.dataset.scrollAmount) : 290;

    if (prev) prev.addEventListener('click', () => carousel.scrollBy({ left: -scrollAmount, behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => carousel.scrollBy({ left: scrollAmount, behavior: 'smooth' }));
  });

  // ---------- Part search tabs ----------
  document.querySelectorAll('[data-tabs]').forEach(tabContainer => {
    const tabs = tabContainer.querySelectorAll('[data-tab]');
    const panels = document.querySelectorAll('[data-tab-panel]');
    tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.tab;
        tabs.forEach(t => t.classList.toggle('part-search__tab--active', t === tab));
        panels.forEach(p => p.style.display = p.dataset.tabPanel === target ? '' : 'none');
      });
    });
  });

  // ---------- Geo language banner ----------
  const geoBanner = document.querySelector('[data-geo-banner]');
  if (geoBanner) {
    const dismissed = localStorage.getItem('voltauto_geo_dismissed');
    const currentLocale = document.documentElement.lang || 'fr';
    const browserLang = (navigator.language || '').slice(0, 2).toLowerCase();

    // Show banner if: not dismissed AND browser language differs from current site language
    if (!dismissed && browserLang && browserLang !== currentLocale && browserLang !== 'fr') {
      setTimeout(() => geoBanner.setAttribute('data-visible', 'true'), 1500);
    }

    geoBanner.querySelectorAll('[data-geo-dismiss]').forEach(btn => {
      btn.addEventListener('click', () => {
        geoBanner.setAttribute('data-visible', 'false');
        localStorage.setItem('voltauto_geo_dismissed', '1');
      });
    });

    const acceptBtn = geoBanner.querySelector('[data-geo-accept]');
    if (acceptBtn && acceptBtn.dataset.targetUrl) {
      acceptBtn.addEventListener('click', () => {
        localStorage.setItem('voltauto_geo_dismissed', '1');
        window.location.href = acceptBtn.dataset.targetUrl;
      });
    }
  }

  // ---------- Form submission with webhook + fallback ----------
  document.querySelectorAll('form[data-voltauto-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      const webhookUrl = form.dataset.webhookUrl;
      const formType = form.dataset.formType;
      const successMessage = form.dataset.successMessage || 'Merci, votre message a bien été envoyé. Nous vous recontactons rapidement.';

      // Honeypot check (anti-spam)
      const honeypot = form.querySelector('[name="honeypot_field"]');
      if (honeypot && honeypot.value) {
        e.preventDefault();
        console.warn('VOLTAUTO: Honeypot triggered');
        return;
      }

      // If a webhook URL is set, POST there via fetch (intercepting form submission)
      if (webhookUrl) {
        e.preventDefault();
        const submitBtn = form.querySelector('[type="submit"]');
        const originalBtnText = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Envoi en cours…';
        }

        const formData = new FormData(form);
        const payload = Object.fromEntries(formData);
        payload.form_type = formType;
        payload.source_page = window.location.pathname;
        payload.timestamp = new Date().toISOString();
        payload.language = document.documentElement.lang || 'fr';
        payload.user_agent = navigator.userAgent;

        try {
          const response = await fetch(webhookUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });

          if (response.ok) {
            // Show success state
            const successEl = form.querySelector('[data-form-success]');
            if (successEl) {
              successEl.textContent = successMessage;
              successEl.style.display = 'block';
            }
            form.reset();
            if (submitBtn) submitBtn.textContent = '✓ Envoyé';
            setTimeout(() => {
              if (successEl) successEl.style.display = 'none';
              if (submitBtn) {
                submitBtn.textContent = originalBtnText;
                submitBtn.disabled = false;
              }
            }, 6000);
          } else {
            throw new Error('Webhook failed');
          }
        } catch (err) {
          console.error('VOLTAUTO form submit error:', err);
          // Fallback: submit form normally (to Shopify contact endpoint)
          form.removeAttribute('data-webhook-url');
          form.submit();
        }
      }
      // If no webhook URL, the form submits natively to Shopify (action="/contact#contact_form")
    });
  });

  // ---------- Quantity selectors (for cart, product page) ----------
  document.querySelectorAll('[data-quantity-wrapper]').forEach(wrapper => {
    const input = wrapper.querySelector('input[type="number"]');
    const minus = wrapper.querySelector('[data-quantity-minus]');
    const plus = wrapper.querySelector('[data-quantity-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', () => { input.stepDown(); input.dispatchEvent(new Event('change', { bubbles: true })); });
    if (plus) plus.addEventListener('click', () => { input.stepUp(); input.dispatchEvent(new Event('change', { bubbles: true })); });
  });

  // ---------- Galerie produit : photos, vidéo, documents, zoom ----------
  /* RECONSTRUIT LE 20/10/2026. Le contrôleur d'origine a été perdu en poussant
     un `theme.js` périmé par-dessus celui du thème ; il n'en restait qu'un
     échangeur de `src`, qui ne savait rien des documents, de la vidéo ni du
     zoom. Celui-ci est réécrit depuis le CONTRAT que portent le balisage de
     `sections/main-product.liquid` et les classes de `theme.css`.

     Le cadre a trois états, et un seul à la fois :
     · PHOTO   — l'image, et les deux loupes ;
     · VIDÉO   — `.product-gallery__main--video`, lecteur en 16/9 ;
     · DOCUMENT— `.product-gallery__main--doc`, soit le PDF, soit le message
                 « à venir ».

     Deux règles que les commentaires du gabarit posent explicitement :
     · l'`iframe` d'un document ou d'une vidéo N'A PAS de `src` au chargement —
       il est posé au PREMIER clic (un PV de contrôle technique pèse facilement
       un mégaoctet, une intégration YouTube pose ses cookies dès qu'elle
       existe) ;
     · le lecteur vidéo est DÉTRUIT quand on revient aux photos, sinon la
       bande-son continue dans un cadre que personne ne voit. */
  document.querySelectorAll('[data-product-gallery]').forEach(galerie => {
    const cadre = galerie.querySelector('[data-gallery-main]');
    if (!cadre) return;
    const image = cadre.querySelector('img');
    const voletVideo = galerie.querySelector('[data-gallery-video]');
    const voletDoc = galerie.querySelector('[data-gallery-doc]');
    const cadreDoc = galerie.querySelector('[data-gallery-doc-cadre]');
    const attente = galerie.querySelector('[data-gallery-doc-attente]');
    const attenteTitre = galerie.querySelector('[data-gallery-doc-attente-titre]');
    const attenteTexte = galerie.querySelector('[data-gallery-doc-attente-texte]');
    const lienPlein = galerie.querySelector('[data-gallery-doc-lien]');
    const boiteZoom = galerie.querySelector('[data-gallery-zoom]');
    const zoomPlus = galerie.querySelector('[data-gallery-zoom-in]');
    const zoomMoins = galerie.querySelector('[data-gallery-zoom-out]');
    const pellicules = Array.from(galerie.querySelectorAll('[data-gallery-thumb]'));

    const ZOOM_MIN = 1, ZOOM_MAX = 3, ZOOM_PAS = 0.5;
    let echelle = 1, dx = 0, dy = 0;

    function appliquerZoom() {
      if (!image) return;
      image.style.transform =
        'translate(' + dx + 'px,' + dy + 'px) scale(' + echelle + ')';
      cadre.classList.toggle('product-gallery__main--zoome', echelle > 1);
      if (zoomMoins) zoomMoins.disabled = echelle <= ZOOM_MIN;
      if (zoomPlus) zoomPlus.disabled = echelle >= ZOOM_MAX;
    }
    function remettreZoom() { echelle = 1; dx = 0; dy = 0; appliquerZoom(); }

    /* CHANGER `src` NE SUFFIT PAS. Shopify sert l'image d'ouverture avec un
       `srcset` de trois variantes ; tant qu'il est là, le navigateur continue
       d'afficher CELLE-CI et ignore le `src` qu'on vient de poser — le cadre
       restait donc sur la photo principale quelle que soit la pellicule
       cliquée (constaté par Léo le 20/10/2026, après que le banc l'eut laissé
       passer : jsdom n'implémente pas `srcset`).

       On retire donc `srcset` et `sizes` avant de poser le `src`. Rien n'est
       perdu : la pellicule porte déjà l'URL en pleine largeur (`width: 1200`),
       qui est la plus grande des trois variantes. */
    function poserImage(src) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = src;
    }

    /* Repartir des photos : c'est le seul endroit qui DÉTRUIT le lecteur
       vidéo. Vider `innerHTML` coupe le son aussi sûrement que retirer
       l'iframe, et laisse le volet prêt pour un prochain clic. */
    function montrerPhoto(src) {
      if (voletVideo) { voletVideo.innerHTML = ''; voletVideo.hidden = true; }
      if (voletDoc) voletDoc.hidden = true;
      cadre.classList.remove('product-gallery__main--doc', 'product-gallery__main--video');
      if (image) {
        if (src) poserImage(src);
        image.hidden = false;
      }
      remettreZoom();
      if (boiteZoom) boiteZoom.hidden = !image;
    }

    function montrerVideo(embed) {
      if (!voletVideo) return;
      if (voletDoc) voletDoc.hidden = true;
      if (boiteZoom) boiteZoom.hidden = true;
      remettreZoom();
      cadre.classList.remove('product-gallery__main--doc');
      cadre.classList.add('product-gallery__main--video');
      // L'iframe n'existe qu'à partir d'ici : pas de cookie posé avant le clic.
      const cadreVideo = document.createElement('iframe');
      cadreVideo.setAttribute('src', embed);
      cadreVideo.setAttribute('title', 'Le véhicule en vidéo');
      cadreVideo.setAttribute('allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      cadreVideo.setAttribute('allowfullscreen', '');
      cadreVideo.setAttribute('loading', 'lazy');
      voletVideo.innerHTML = '';
      voletVideo.appendChild(cadreVideo);
      voletVideo.hidden = false;
    }

    /* Un volet document sert DEUX cas : le PDF, et le « à venir ». Les deux
       occupent le même cadre, et jamais en même temps — d'où les `hidden`
       posés des deux côtés à chaque passage. */
    function montrerDocument(url, titre, texteAttente) {
      if (!voletDoc) return;
      if (voletVideo) { voletVideo.innerHTML = ''; voletVideo.hidden = true; }
      if (boiteZoom) boiteZoom.hidden = true;
      remettreZoom();
      cadre.classList.remove('product-gallery__main--video');
      cadre.classList.add('product-gallery__main--doc');

      const aUnDocument = !!url;
      if (cadreDoc) {
        if (aUnDocument && cadreDoc.getAttribute('src') !== url) cadreDoc.setAttribute('src', url);
        cadreDoc.hidden = !aUnDocument;
      }
      if (lienPlein) {
        lienPlein.hidden = !aUnDocument;
        if (aUnDocument) lienPlein.setAttribute('href', url);
      }
      if (attente) attente.hidden = aUnDocument;
      if (!aUnDocument) {
        if (attenteTitre) attenteTitre.textContent = titre || 'Document';
        if (attenteTexte) attenteTexte.textContent = texteAttente || '';
      }
      voletDoc.hidden = false;
    }

    pellicules.forEach(pellicule => {
      pellicule.addEventListener('click', () => {
        pellicules.forEach(p =>
          p.classList.toggle('product-gallery__thumb--active', p === pellicule));

        const video = pellicule.getAttribute('data-video');
        const doc = pellicule.getAttribute('data-doc');
        const docAttente = pellicule.getAttribute('data-doc-attente');

        if (video) montrerVideo(video);
        else if (doc) montrerDocument(doc, pellicule.getAttribute('data-doc-titre'), null);
        else if (docAttente !== null) montrerDocument(null, pellicule.getAttribute('data-doc-titre'), docAttente);
        else montrerPhoto(pellicule.getAttribute('data-src')
          || (pellicule.querySelector('img') && pellicule.querySelector('img').src));
      });
    });

    if (zoomPlus) zoomPlus.addEventListener('click', () => {
      echelle = Math.min(ZOOM_MAX, echelle + ZOOM_PAS); appliquerZoom();
    });
    if (zoomMoins) zoomMoins.addEventListener('click', () => {
      echelle = Math.max(ZOOM_MIN, echelle - ZOOM_PAS);
      if (echelle === ZOOM_MIN) { dx = 0; dy = 0; }
      appliquerZoom();
    });

    /* Une fois la photo grossie, le doigt la DÉPLACE. Le CSS rend la main au
       script (`touch-action: none`) uniquement dans cet état : hors zoom, la
       page doit continuer de défiler normalement sous le doigt. */
    if (image) {
      let tire = false, departX = 0, departY = 0;
      image.addEventListener('pointerdown', e => {
        if (echelle <= 1) return;
        tire = true; departX = e.clientX - dx; departY = e.clientY - dy;
        if (image.setPointerCapture) image.setPointerCapture(e.pointerId);
      });
      image.addEventListener('pointermove', e => {
        if (!tire) return;
        dx = e.clientX - departX; dy = e.clientY - departY;
        appliquerZoom();
      });
      ['pointerup', 'pointercancel'].forEach(ev =>
        image.addEventListener(ev, () => { tire = false; }));
      image.addEventListener('dblclick', () => {
        echelle = echelle > 1 ? 1 : 2;
        if (echelle === 1) { dx = 0; dy = 0; }
        appliquerZoom();
      });
    }

    // Au chargement, le cadre montre la photo d'ouverture : les loupes servent.
    if (boiteZoom && image) boiteZoom.hidden = false;
    appliquerZoom();
  });

  // ---------- Instagram feed lazy load (Behold integration) ----------
  const igFeedContainers = document.querySelectorAll('[data-instagram-feed]');
  igFeedContainers.forEach(container => {
    const provider = container.dataset.provider;

    if (provider === 'behold' && container.dataset.feedId) {
      // Inject Behold widget script
      const script = document.createElement('script');
      script.src = 'https://w.behold.so/widget.js';
      script.type = 'module';
      script.defer = true;
      document.head.appendChild(script);
    }

    if (provider === 'custom_json' && container.dataset.jsonUrl) {
      // Fetch JSON and render
      fetch(container.dataset.jsonUrl)
        .then(r => r.json())
        .then(data => {
          if (!Array.isArray(data)) return;
          const target = container.querySelector('[data-ig-target]');
          if (!target) return;
          target.innerHTML = data.slice(0, 6).map(post => `
            <a href="${escapeHtml(post.permalink)}" target="_blank" rel="noopener" class="ig-card">
              <img src="${escapeHtml(post.thumbnail_url)}" alt="${escapeHtml(post.caption || '').slice(0, 80)}" loading="lazy">
              <div class="ig-card__play"><svg viewBox="0 0 24 24"><polygon points="8 5 19 12 8 19 8 5"/></svg></div>
              <div class="ig-card__meta">
                <div class="ig-card__caption">${escapeHtml((post.caption || '').slice(0, 120))}</div>
                <div class="ig-card__stats">
                  <span>${formatNumber(post.like_count || 0)} ♥</span>
                  <span>${formatDate(post.timestamp)}</span>
                </div>
              </div>
            </a>
          `).join('');
        })
        .catch(err => console.warn('Instagram JSON fetch failed:', err));
    }
  });

  // ---------- Utility functions ----------
  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  }
  function formatNumber(n) {
    if (n >= 1000) return (n / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
    return n.toString();
  }
  function formatDate(timestamp) {
    if (!timestamp) return '';
    const d = new Date(timestamp);
    const diff = (Date.now() - d.getTime()) / 1000;
    if (diff < 86400) return Math.floor(diff / 3600) + 'h';
    if (diff < 2592000) return Math.floor(diff / 86400) + 'j';
    if (diff < 31536000) return Math.floor(diff / 2592000) + 'mois';
    return Math.floor(diff / 31536000) + 'an';
  }

  // Expose utilities globally
  window.VOLTAUTO = { escapeHtml, formatNumber, formatDate };

})();


/* ==========================================================================
   PAGES LÉGALES — sommaire, accordéon, recherche
   Gabarit `templates/policy.json` → `sections/voltauto-policy.liquid`.

   Une politique Shopify est UN SEUL BLOC HTML : son texte vit dans l'admin,
   pas dans des blocs de thème. Le découpage en sections repliables se fait
   donc ici, sur les `<h2>`, et non en Liquid.

   AMÉLIORATION PROGRESSIVE, PAS DÉPENDANCE. Le Liquid sert la politique en
   entier dans `.va-policy__raw`, mise en forme et lisible. Ce script ne fait
   que la RÉORGANISER. S'il ne trouve pas au moins deux `<h2>`, il ne touche à
   rien : mieux vaut un texte long qu'un accordéon à une seule case. Sur une
   page qui engage juridiquement, aucune clause ne doit dépendre d'un script.

   TROIS CHOSES QU'IL NE FAUT PAS CASSER, constatées sur les CGV en ligne :
   ① les `<h2>` portent DÉJÀ des ancres (`#svc-atelier`) qui ont pu être
     partagées ou citées — on les garde, on n'en fabrique une que si le titre
     n'en a pas ;
   ② un sommaire écrit à la main ouvre le texte — il ferait doublon avec le
     sommaire latéral, donc on le retire, mais SEULEMENT quand le latéral est
     effectivement affiché, et seulement si la liste ne pointe QUE vers des
     sections de cette page ;
   ③ les titres sont déjà numérotés (« 1. Le site ») — on retire ce numéro de
     l'affichage puisque la pastille le porte, mais pas du texte cherché.
   ========================================================================== */
(function () {
  'use strict';

  var racine = document.querySelector('[data-va-policy]');
  if (!racine) return;

  /* ---------- Bouton « Retour au véhicule » ----------
     N'apparaît que si le visiteur vient d'une fiche produit. On mémorise le
     référent en session : suivre une ancre du sommaire ne doit pas faire
     perdre le chemin du retour. */
  (function boutonRetour() {
    var fab = document.querySelector('[data-va-policy-back]');
    if (!fab) return;

    var CLE = 'va_policy_retour';
    var memorise = '';
    try { memorise = sessionStorage.getItem(CLE) || ''; } catch (e) {}

    var cible = '';
    if (document.referrer) {
      try {
        var u = new URL(document.referrer);
        if (u.origin === window.location.origin && /\/products\//.test(u.pathname)) {
          cible = u.href;
          try { sessionStorage.setItem(CLE, cible); } catch (e) {}
        }
      } catch (e) {}
    }
    if (!cible && /\/products\//.test(memorise)) cible = memorise;
    if (!cible) return;

    fab.hidden = false;
    setTimeout(function () { fab.classList.add('est-visible'); }, 40);
    fab.addEventListener('click', function () {
      if (document.referrer === cible && window.history.length > 1) window.history.back();
      else window.location.href = cible;
    });
  })();

  var brut = racine.querySelector('[data-va-policy-raw]');
  var hote = racine.querySelector('[data-va-policy-sections]');
  if (!brut || !hote) return;

  /* Le corps peut arriver enveloppé (Shopify pose parfois un `.rte`). On
     descend dans l'enveloppe unique plutôt que de conclure « pas de titres ». */
  var porteur = brut;
  for (var garde = 0; garde < 3; garde++) {
    if (porteur.querySelector(':scope > h2')) break;
    var enfants = Array.prototype.filter.call(porteur.children, function (el) { return true; });
    if (enfants.length === 1 && enfants[0].querySelector('h2')) porteur = enfants[0];
    else break;
  }

  var titres = Array.prototype.slice.call(porteur.children).filter(function (el) {
    return el.tagName === 'H2';
  });

  // Moins de deux titres : rien à découper, on laisse le texte tel quel.
  if (titres.length < 2) return;

  /* ---------- Ancres ----------
     On garde l'ancre existante. À défaut, on la fabrique à partir du TEXTE du
     titre et non de son rang : une renumérotation ne doit pas casser un lien. */
  var prises = {};
  function fabriquerAncre(texte) {
    var base = sansNumero(texte)
      .toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'section';
    if (prises[base]) { prises[base] += 1; return base + '-' + prises[base]; }
    prises[base] = 1;
    return base;
  }
  function sansNumero(s) { return (s || '').trim().replace(/^\d+\s*[.)]\s*/, ''); }
  function normaliser(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  var CARET = '<svg class="va-policy__section-caret" width="14" height="14" viewBox="0 0 14 14"'
            + ' fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"'
            + ' aria-hidden="true"><path d="M3 5l4 4 4-4"/></svg>';

  var entrees = [];
  titres.forEach(function (h2, i) {
    var titreBrut = (h2.textContent || '').trim();
    var id = h2.id || fabriquerAncre(titreBrut);

    var details = document.createElement('details');
    details.className = 'va-policy__section';
    details.id = id;
    details.setAttribute('data-va-policy-section', '');

    var tete = document.createElement('summary');
    tete.className = 'va-policy__section-head';
    tete.innerHTML =
      '<span class="va-policy__section-num">' + ('0' + (i + 1)).slice(-2) + '</span>' +
      '<span class="va-policy__section-title" data-va-policy-foin></span>' + CARET;
    // Le titre est posé en TEXTE, jamais en HTML : il vient de l'admin.
    tete.querySelector('[data-va-policy-foin]').textContent = sansNumero(titreBrut);
    details.appendChild(tete);

    var corps = document.createElement('div');
    corps.className = 'va-policy__section-body';
    corps.setAttribute('data-va-policy-foin', '');
    // On DÉPLACE les nœuds d'origine : pas de innerHTML, donc pas de
    // réinterprétation du HTML écrit par Shopify.
    var n = h2.nextSibling;
    while (n && !(n.nodeType === 1 && n.tagName === 'H2')) {
      var suivant = n.nextSibling;
      corps.appendChild(n);
      n = suivant;
    }
    details.appendChild(corps);
    h2.parentNode.removeChild(h2);
    hote.appendChild(details);

    entrees.push({ element: details, id: id, titre: sansNumero(titreBrut) });
  });

  var sections = entrees.map(function (e) { return e.element; });
  var idsConnus = {};
  entrees.forEach(function (e) { idsConnus[e.id] = true; });

  /* ---------- Sommaire latéral ---------- */
  var toc = racine.querySelector('[data-va-policy-toc]');
  var tocListe = racine.querySelector('[data-va-policy-toc-list]');
  var liens = [];
  if (toc && tocListe) {
    entrees.forEach(function (e) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + e.id;
      a.textContent = e.titre;
      li.appendChild(a);
      tocListe.appendChild(li);
      liens.push(a);
    });
    toc.hidden = false;
    // La grille à deux colonnes n'est posée qu'ICI : le sommaire existe
    // maintenant, il a de quoi remplir la première colonne.
    var grille = racine.querySelector('[data-va-policy-layout]');
    if (grille && grille.getAttribute('data-va-policy-sommaire') === 'oui') {
      grille.classList.add('va-policy__layout--sommaire');
    }
    retirerSommaireMaison();
  }
  // Pas de sommaire latéral : on ne touche à rien. Une seule colonne, pleine
  // largeur, et le sommaire écrit dans l'admin reste le seul qu'il y ait.

  /* Retire la liste d'ancres écrite dans l'admin, et son étiquette, parce que
     le sommaire latéral la refait. Test strict : la liste ne doit contenir QUE
     des liens vers des sections de cette page. Une liste qui sort de la page
     n'est pas un sommaire, et on n'y touche pas. */
  function retirerSommaireMaison() {
    // Le sommaire écrit dans l'admin se présente sous DEUX formes selon la
    // façon dont le texte a été rédigé : une liste nue précédée d'une
    // étiquette, ou une liste enveloppée dans un <nav> qui porte déjà son
    // titre (constaté en ligne le 20/10/2026 : <nav class="legal-doc__sommaire">).
    // On traite les deux, et on ne se fie JAMAIS à la classe ni au mot
    // « Sommaire » — seulement à ce que fait la liste : ne pointer QUE vers
    // des sections de cette page.
    var candidats = Array.prototype.slice.call(porteur.children);
    candidats.forEach(function (bloc) {
      var liste = /^(ol|ul)$/i.test(bloc.tagName)
        ? bloc
        : bloc.querySelector(':scope > ol, :scope > ul');
      if (!liste) return;

      var liens = bloc.querySelectorAll('a');
      var ancres = bloc.querySelectorAll('a[href^="#"]');
      if (!ancres.length || liens.length !== ancres.length) return;

      var toutesConnues = Array.prototype.every.call(ancres, function (a) {
        var cible = a.getAttribute('href').slice(1);
        try { cible = decodeURIComponent(cible); } catch (e) {}
        return idsConnus[cible];
      });
      if (!toutesConnues) return;

      // Enveloppé : on retire le bloc entier, son titre avec lui. Nu : on
      // retire la liste, puis l'étiquette courte qui la précédait.
      if (liste === bloc) {
        var etiquette = bloc.previousElementSibling;
        bloc.parentNode.removeChild(bloc);
        if (etiquette && /^(p|strong|b|h2|h3|h4)$/i.test(etiquette.tagName)
            && (etiquette.textContent || '').trim().split(/\s+/).length <= 3) {
          etiquette.parentNode.removeChild(etiquette);
        }
      } else {
        bloc.parentNode.removeChild(bloc);
      }
    });
  }

  /* ---------- Ce qui précédait le premier titre ----------
     Un chapeau, une adresse, un avertissement : ça ne se perd pas. Ce qui
     reste dans le corps brut après découpe est reposé au-dessus de
     l'accordéon ; s'il ne reste rien, le bloc disparaît. */
  if ((porteur.textContent || '').trim() === '' && !porteur.querySelector('img, table')) {
    brut.hidden = true;
  } else {
    brut.classList.add('va-policy__raw--chapeau');
  }
  hote.hidden = false;

  /* ---------- Commandes ---------- */
  var commandes = racine.querySelector('[data-va-policy-controls]');
  if (commandes) commandes.hidden = false;

  var champ = racine.querySelector('[data-va-policy-search]');
  var compteur = racine.querySelector('[data-va-policy-count]');
  var vide = racine.querySelector('[data-va-policy-empty]');
  var deplier = racine.querySelector('[data-va-policy-expand-all]');
  var replier = racine.querySelector('[data-va-policy-collapse-all]');

  function filtrer() {
    if (!champ) return;
    var q = normaliser(champ.value.trim());
    var visibles = 0;
    sections.forEach(function (sec) {
      if (q.length < 2) {
        sec.classList.remove('is-masquee');
        visibles++;
        return;
      }
      var foin = '';
      sec.querySelectorAll('[data-va-policy-foin]').forEach(function (el) {
        foin += ' ' + (el.textContent || '');
      });
      if (normaliser(foin).indexOf(q) !== -1) {
        sec.classList.remove('is-masquee');
        sec.setAttribute('open', '');
        visibles++;
      } else {
        sec.classList.add('is-masquee');
      }
    });
    if (compteur) {
      compteur.hidden = q.length < 2;
      compteur.textContent = visibles + ' résultat' + (visibles > 1 ? 's' : '');
    }
    if (vide) vide.hidden = visibles > 0;
  }

  if (champ) {
    var minuteur;
    champ.addEventListener('input', function () {
      clearTimeout(minuteur);
      minuteur = setTimeout(filtrer, 120);
    });
  }
  if (deplier) deplier.addEventListener('click', function () {
    sections.forEach(function (s) { s.setAttribute('open', ''); });
  });
  if (replier) replier.addEventListener('click', function () {
    sections.forEach(function (s) { s.removeAttribute('open'); });
  });

  /* ---------- Ancres ----------
     Le découpage se faisant après le chargement, le navigateur a déjà renoncé
     à l'ancre de l'URL : on la rejoue nous-mêmes. */
  function suivreAncre() {
    var h = window.location.hash.replace('#', '');
    if (!h) return;
    try { h = decodeURIComponent(h); } catch (e) {}
    var cible = document.getElementById(h);
    if (!cible || !cible.classList.contains('va-policy__section')) return;
    cible.setAttribute('open', '');
    cible.classList.add('is-signalee');
    setTimeout(function () { cible.classList.remove('is-signalee'); }, 2400);
    setTimeout(function () {
      window.scrollTo({ top: cible.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' });
    }, 50);
  }
  suivreAncre();
  window.addEventListener('hashchange', suivreAncre);

  /* ---------- Section courante dans le sommaire ---------- */
  if (liens.length && 'IntersectionObserver' in window) {
    var parId = {};
    liens.forEach(function (a) { parId[a.getAttribute('href').slice(1)] = a; });
    var vue = new IntersectionObserver(function (lots) {
      lots.forEach(function (lot) {
        var a = parId[lot.target.id];
        if (!a || !lot.isIntersecting) return;
        liens.forEach(function (x) { x.classList.remove('is-courant'); });
        a.classList.add('is-courant');
      });
    }, { rootMargin: '-100px 0px -70% 0px' });
    sections.forEach(function (s) { vue.observe(s); });
  }
})();
